import BuchungBestaetigungBase from '../../../pages/BuchungBestaetigung';
export default BuchungBestaetigungBase;
